// extracted by mini-css-extract-plugin
export default {"CardBaseWithSash":"index-module__CardBaseWithSash--bKWdb"};